
if (!customElements.get('ulg-footwear-sizes')) {
  const normalise = value => String(value).trim().toLowerCase().replace(/,/g,'.').replace(/½/g,' 1/2').replace(/⅓/g,' 1/3').replace(/⅔/g,' 2/3').replace(/¼/g,' 1/4').replace(/¾/g,' 3/4').replace(/(\d+)\s+(\d)\/(\d)/g,(_,a,b,c)=>String(Number(a)+Number(b)/Number(c))).replace(/\s/g,'').replace(/\.0+$/,'');
  const singleNumber = '\\d+(?:[.,]\\d+)?(?:\\s+[123]\\/[234])?[½⅓⅔¼¾]?';
  const number = singleNumber+'(?:[–-]'+singleNumber+')?';
  const system = 'US(?:\\s*[-]\\s*[MW])?|UK|EUR?';
  const parse = (label,sex='men') => {
    const result = {};
    const save = (unit,size) => { const key=unit.toUpperCase().startsWith('EU')?'EU':unit.toUpperCase().startsWith('US')?'US':'UK'; result[key]=size.trim().replace(/,/g,'.').replace(/\.0(?=\s|$)/,''); };
    for (const match of label.matchAll(new RegExp('\\b('+system+')\\s*[:\\-]?\\s*('+number+')(?![\\d.])','gi'))) save(match[1],match[2]);
    for (const match of label.matchAll(new RegExp('('+number+')\\s*('+system+')\\b','gi'))) save(match[2],match[1]);
    const pairs={};
    const sexToken="(?:Men(?:'s)?|Women(?:'s)?|M|W)";
    const keep=(token,value)=>{pairs[/^w/i.test(token)?'US-W':'US-M']=value.trim();};
    for(const match of label.matchAll(new RegExp('(?:US\\s*[-]?\\s*)?('+sexToken+')\\s*('+number+')','gi')))keep(match[1],match[2]);
    for(const match of label.matchAll(new RegExp('('+number+')\\s+(?:US\\s*[-]?\\s*)?('+sexToken+')\\b','gi')))keep(match[2],match[1]);
    for(const match of label.matchAll(new RegExp('('+number+')\\s*US\\s*[-]\\s*([MW])\\b','gi')))keep(match[2],match[1]);
    Object.assign(result,pairs);
    if(Object.keys(pairs).length)result.US=pairs[sex==='women'?'US-W':'US-M'];
    return result;
  };
  const gender = value => /women|female|\bus\s*[-]?\s*w\b/i.test(value)?'women':/men|male|\bus\s*[-]?\s*m\b/i.test(value)?'men':null;
  const columnSystem = (label,sex) => {
    if (/\bus\b/i.test(label)) { const other=gender(label); return other && sex && other!==sex?null:'US'; }
    if (/\buk\b/i.test(label)) return 'UK';
    if (/\beur?\b/i.test(label)) return 'EU';
    return null;
  };
  customElements.define('ulg-footwear-sizes',class extends HTMLElement {
    connectedCallback() {
      this.frame=requestAnimationFrame(()=>this.initialise());
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); }
    initialise() {
      if(this.ready)return;
      const inputs=Array.from(this.querySelectorAll('input[type="radio"]'));
      const sex=gender(this.dataset.productTitle) || 'men';
      const dual=/^(norda|bedrock|tarkine)\b/i.test(this.dataset.productTitle||'');
      this.entries=inputs.map(input=>({input,text:input.closest('label')?.querySelector('.ulg-text-variant-option'),original:input.value,sizes:parse(input.value,sex)}));
      if(!this.entries.length || this.entries.some(entry=>!entry.text))return;
      this.ready=true;
      const guideRows=[];
      document.querySelectorAll('ulg-size-guide[data-product-id="'+this.dataset.productId+'"] [data-guide-panel]').forEach(panel=>{
        const guideSex=gender(panel.dataset.guideHandle||'');
        if(guideSex && guideSex!==sex)return;
        panel.querySelectorAll('table').forEach(table=>{
          const rows=Array.from(table.rows);
          const headerIndex=rows.findIndex(row=>Array.from(row.cells).filter(cell=>columnSystem(cell.textContent,sex)).length>=2);
          if(headerIndex<0)return;
          const columns=Array.from(rows[headerIndex].cells).map(cell=>columnSystem(cell.textContent,sex));
          rows.slice(headerIndex+1).forEach(row=>{
            const values={};
            Array.from(row.cells).forEach((cell,index)=>{if(columns[index] && /^[\d\s.,/½⅓⅔¼¾]+$/.test(cell.textContent.trim()))values[columns[index]]=cell.textContent.trim().replace(/,/g,'.');});
            if(Object.keys(values).length>=2)guideRows.push(values);
          });
        });
      });
      this.entries.forEach(entry=>{
        const known=Object.entries(entry.sizes).filter(([unit])=>['US','UK','EU'].includes(unit));
        if(!known.length)return;
        const matches=guideRows.filter(row=>known.every(([unit,value])=>row[unit] && normalise(row[unit])===normalise(value)));
        for(const unit of ['US','UK','EU']) {
          const values=matches.map(row=>row[unit]).filter(Boolean);
          if(!entry.sizes[unit] && values.length===matches.length && values.length && new Set(values.map(normalise)).size===1)entry.sizes[unit]=values[0];
        }
      });
      if(dual) this.entries.forEach(entry=>{
        const preferred=sex==='women'?'US-W':'US-M';
        if(entry.sizes.US && !entry.sizes[preferred])entry.sizes[preferred]=entry.sizes.US;
        if(!/^bedrock\b/i.test(this.dataset.productTitle||'')){
          if(!entry.sizes['US-W'] && entry.sizes['US-M'])entry.sizes['US-W']=String(Number(entry.sizes['US-M'])+1.5);
          if(!entry.sizes['US-M'] && entry.sizes['US-W'])entry.sizes['US-M']=String(Number(entry.sizes['US-W'])-1.5);
        }
      });
      const unitOrder=dual?(sex==='women'?['US-W','US-M','UK','EU']:['US-M','US-W','UK','EU']):['US','UK','EU'];
      const units=unitOrder.filter(unit=>this.entries.some(entry=>entry.sizes[unit]));
      if(units.length<2)return;
      const tabs=document.createElement('div');
      tabs.className='ulg-footwear-size-tabs';
      tabs.setAttribute('role','group');
      tabs.setAttribute('aria-label',inputs[0].name);
      this.buttons=units.map(unit=>{
        const button=document.createElement('button');button.type='button';button.textContent=unit==='US-M'?'US Men':unit==='US-W'?'US Women':unit;button.dataset.sizeSystem=unit;
        button.addEventListener('click',()=>{this.setSystem(unit);try{sessionStorage.setItem('ulg-footwear-system-'+this.dataset.productId,unit);}catch(_){}});
        tabs.append(button);return button;
      });
      this.prepend(tabs);
      let selected=units[0];
      try{const saved=sessionStorage.getItem('ulg-footwear-system-'+this.dataset.productId);if(units.includes(saved))selected=saved;}catch(_){}
      this.setSystem(selected);
    }
    setSystem(unit) {
      this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.sizeSystem===unit)));
      this.entries.forEach(entry=>{
        const label=entry.sizes[unit] || entry.original;
        const fraction=label.match(/^(.*?\d)\s*([123]\/[234]|[½⅓⅔¼¾])$/);
        entry.text.textContent=fraction?fraction[1]:label;
        entry.text.style.columnGap=fraction?'.08em':'';
        if(fraction) {
          const small=document.createElement('span');
          small.textContent=({'1/2':'½','1/3':'⅓','2/3':'⅔','1/4':'¼','3/4':'¾'})[fraction[2]] || fraction[2];
          small.style.cssText='font-size:.8em;line-height:1;vertical-align:super;transform:translateY(-.18em);';
          entry.text.append(small);
        }
        entry.input.setAttribute('aria-label',entry.sizes[unit]?unit+' '+entry.sizes[unit]:entry.original+' (conversion unavailable)');
      });
      this.dataset.selectedSystem=unit;
    }
  });
}
